import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import poolsActions from '../actions/pools'

export const usePools = () => {
  const data = useSelector((state) => {
    return get(state, 'app.poolsManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(poolsActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
